import { MuiComponent } from "./type";
import * as Colors from "../colors";

export const MuiSelect: MuiComponent<"MuiSelect"> = {
  styleOverrides: {
    root: {
      backgroundColor: Colors.Gray,
      // borderBottom: `2px solid ${Colors.Blue}`,
      borderRadius: '12px',
      border: `1px solid ${Colors.BorderGray}`
    },
    select: {
      padding: '10px 14px'
    }
  },
};